<template>
  <v-data-table
    dense
    :headers="[
      { text: 'Code', value: 'code' },
      { text: 'Tower', value: 'tower.name' },
      { text: 'Floor', value: 'floor.name' }
    ]"
    sort-by="code"
    :items="inventory"
    :items-per-page="10"
  >
    <template #top>
      <span class=" text-h6 grey--text">
        Propiedades
      </span>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "DevelopmentDetailInventoryTable",
  props: {
    inventory: { type: Array }
  }
};
</script>

<style scoped>
.card--outlined {
  border: 1px solid #e0e0e0;
  margin: 0.5rem;
}
</style>
